export default "__VITE_ASSET__D8jw1bsH__"